// extracted by mini-css-extract-plugin
export default {"subNav":"FlexTemplate-module__subNav--TLgu7","trailingSectionGrid":"FlexTemplate-module__trailingSectionGrid--lWrVg"};